<template lang="pug">
  include ../../../../pug/mixins/bem
  +b.poll-wrapper
    +e.element
      +e.close.A(
        href=''
        @click.prevent='$emit("close")'
      ) &times;
      +e.content
        component(
          :is='current',
          @next='setData($event)',
          
        )
</template>

<script>

import InitStep from './steps/init'
import AgeStep from './steps/age'
import Products from './steps/products'
import Brands from './steps/brands'
import Promo from './steps/promo'
import Form from './steps/form'
import Success from './steps/success'
import Moz from './steps/moz'

import VendorService from '@shared/services/vendor.js'
import {
  getCookie,
  setCookie
} from '@shared/utils/helpers'

export default {
  name: 'PollStart',
  components: {
    AgeStep,
    InitStep,
    Products,
    Brands,
    Form,
    Promo,
    Success,
    Moz,
  },
  data() {
    return {
      current: 'InitStep',
      form: {
        full_name: '',
        phone: '',
        email: '',
        address: '',
        age: '',
        is_porridge: false,
        is_puree: false,
        is_paste: false,
        is_biscuit: false,
        is_milupa: false,
        is_gerber: false,
        is_some_brand: '',
        given_promocode: '',
      },
    }
  },
  methods: {
    setData($event) {
      if (this.form.finish) {
        this.$emit('close')
        return
      }
      this.form = Object.assign(this.form, $event)
      if ($event.finish) {
        this.send($event.save)
        return
      }
      this.current = $event.current
      console.log(this.form, this.current)
    },
    send(save) {
      VendorService.sendPromo(this.form).then(() => {
        setCookie('NEW_PROMO_FORM_IS_SHOWED', true)
        if (save) return 
        this.$emit('close')
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/js/shared/components/poll/Start.vue